import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpHint, Table, cn, defaultColumnsState, renderOrder, } from '@wit-support/ui';
import { columnHint } from '../glossary.js';
const MOMENT_COLUMN_DEFS = [
    { id: 'moment', label: 'Момент', defaultPin: 'left', hideable: false },
    { id: 'h60', label: '60 дн' },
    { id: 'h90', label: '90 дн' },
    { id: 'h120', label: '120 дн' },
    { id: 'coverage', label: 'Покрытие' },
];
/** Колонки в порядке отрисовки (состояние по умолчанию, без хранения). */
export const MOMENT_COLUMNS = renderOrder(defaultColumnsState(MOMENT_COLUMN_DEFS), MOMENT_COLUMN_DEFS);
/** Колонка по id — для `column` у ячеек. */
export function momentColumn(id) {
    return MOMENT_COLUMNS.find((c) => c.id === id);
}
/** Сколько колонок занимает строка «ошибка» / «загрузка» после «Момента». */
export const MOMENT_VALUE_SPAN = MOMENT_COLUMNS.length - 1;
/** Шапка таблицы моментов с пояснением ⓘ у каждой колонки. */
export function MomentsTableHeader({ theta }) {
    return (_jsx(Table.Header, { children: _jsx(Table.Row, { children: MOMENT_COLUMNS.map((col) => {
                const right = col.id !== 'moment';
                const hint = columnHint(col.id, theta);
                return (_jsx(Table.HeaderCell, { column: col, className: cn(right && 'text-right'), children: hint ? (_jsxs("span", { className: cn('inline-flex items-center gap-0.5 align-middle', right && 'flex-row-reverse'), children: [_jsx("span", { children: col.def.label }), _jsx(HelpHint, { label: `Что значит «${col.def.label}»`, children: hint })] })) : (col.def.label) }, col.id));
            }) }) }));
}
//# sourceMappingURL=moments-table.js.map